<template>
	<section class="small-12 unitMap">
        <div class="small-12 columns listingsTitle flex justify-center" style="padding-top:60px;">
            <h3 class="small-12 flex vertical-align">
                The Neighborhood
            </h3>
        </div>
        <div class="small-12 columns propertyMap" style="height:400px;">
            <div class="small-12" ref="unitMap" id="propertyMap" style="height:100%"></div>
        </div>
    </section>
</template>

<script>

	// Import the mixins
	import { BugsnagService } from '@/mixins/services/bugsnag/BugsnagService'

    // Import the map css
	import 'mapbox-gl/dist/mapbox-gl.css'
	
	export default {

		/*
		** Set the component name
		*/

		name: 'UnitMap',

		/*
		**  Register the components
		*/

		components: {

			//

		},

		/*
		**  Register the mixins
		*/

		mixins: [

            BugsnagService

		],

		/*
		**  Set the props
		*/

		props: {

			unit: {
                type: Object,
                default: () => null
            },

            property: {
                type: Object,
                default: () => null
            }

		},

		/*
		**  Set up the data
		*/

		data: () => ({

			accessToken: process.env.VUE_APP_MAPBOX_KEY,
			mapContainer: 'propertyMap',
			style: 'mapbox://styles/nestd/ckdalozr21auv1il29veqzvrh',
			latitude: null,
			longitude: null,
			pitch: 0,
			zoom: 14,
			bearing: 0,
			propertyMap: null,
			marker_image: 'https://firebasestorage.googleapis.com/v0/b/nestd-prod.appspot.com/o/framework%2Fproperty-location-marker.png?alt=media&token=e03446d1-60cb-4fc8-a311-99cabdbf8517'

		}),

		/*
		**  Watch em'
		*/

		watch: {

			property: {

				immediate: true, // Load on created
				handler(property) {

					/*
					**	Render the map
					**	@method: @here
					*/

                    if (property) {

                        if (this.$refs.unitMap) this.renderMap();

                    }

				}

			}

		},

		/*
        ** Do this first
        */

        mounted() {

            /*
            **	Render the map
            **	@method: @here
            */

        	if (this.$refs.unitMap) this.renderMap();

        },

        /*
		**  Set up the methods
		*/

		methods: {

			renderMap: function () {

                try {

                    /*
					**	Set the props
					**	@props: @here
					*/

                    this.latitude = this.property.relationships.places.geometry.location.lat;
                    this.longitude = this.property.relationships.places.geometry.location.lng;

                    /*
					**	Set the access token
					**	@prop: @here
					*/

                    MapboxGL.accessToken = this.accessToken;
 
                    /*
					**	Create the map
					**	@prop: @here
					*/

                    this.propertyMap = new MapboxGL.Map({
                        container: this.mapContainer,
                        style: this.style,
                        center: [this.longitude, this.latitude],
                        zoom: this.zoom,
                        pitch: this.pitch,
                        bearing: this.bearing
                    });
 
                    /*
					**	Disable the scroll zoom
					*/

                    this.propertyMap.scrollZoom.disable();
 
                    /*
					**	Add the navigation control
					*/

                    this.propertyMap.addControl(new MapboxGL.NavigationControl(), 'top-right');

                    /*
					**	Place property marker
					**	@method: @here
					*/

                    this.placeExistingMarkers();

                } catch (e) {

                    /*
                    **  Send to Bugsnag
                    **  @service: Bugsnag/BugsnagService
                    */
                
                    this.reportAuthBugsnagError({
                        title: 'Unable to Render the Mapbox Map',
                        errorType: 'Application',
                        section: 'Components/Property/Units',
                        uid: 'dATeDDuEj2BU2f9bUaSu',
                        error: e
                    });

                }

			},

			placeExistingMarkers: function() {

                try {

                    /*
					**	Set the vars
					*/

                    let lat = this.property.relationships.places.geometry.location.lat,
					lng = this.property.relationships.places.geometry.location.lng,
					existingMarker = document.createElement('div'),
					width = 25,
					height = 25;
 
                    /*
					**	Set the marker's attributes
					*/

                    existingMarker.setAttribute('id', this.property.id);
                    existingMarker.setAttribute('class', 'animated propertyPinMarker');

                    /*
					**	Set the marker
					*/

                    new MapboxGL.Marker(existingMarker).setLngLat([lng, lat]).addTo(this.propertyMap);

                } catch (e) {

                    /*
                    **  Send to Bugsnag
                    **  @service: Bugsnag/BugsnagService
                    */
                
                    this.reportAuthBugsnagError({
                        title: 'Unable to Set an Existing Marker on a Map',
                        errorType: 'Application',
                        section: 'Components/Property/Units',
                        uid: 'pf2e74UbSsV6HpxpINuQ',
                        error: e
                    });

                }

			},

		},

		/*
		**  Set the computed props
		*/

		computed: {

			//

		},

		/*
		**  Set the filters
		*/

		filters: {

			//

		}

	}

</script>